import { Pipe, PipeTransform } from '@angular/core';
import { CustomVariable } from '../../features/chat-bot/types/chat-flow.interface';
import { replaceParamVariables } from '../utils/replace-variables.util';

/**
 * Replaces `<span class="param">variable_name</span>` placeholders in message
 * HTML with their resolved values. Pure pipe: pass the current variables map as
 * the argument so it recomputes when the map reference changes (e.g. when
 * variables are loaded/updated).
 */
@Pipe({
  name: 'replaceVariables',
  standalone: false,
  pure: true
})
export class ReplaceVariablesPipe implements PipeTransform {
  transform(
    value: string | undefined | null,
    variables: CustomVariable | null | undefined
  ): string {
    if (!value) {
      return '';
    }
    return replaceParamVariables(value, variables);
  }
}
